import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash"
import {CausaliGiornata} from "@commons/mapping/PresenzeGiornataPlusRecord";

import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";

export interface RiepilogoOrePlus {
    hPrevMod: number;
    hTotali: number;
    hPrevDiurne: number;
    hPrevDiurneTurno: number;
    hPrevNotturne: number;
    hPausaDiurne: number;
    hPausaNotturne: number;
    hLavDiurne: number;
    hLavNotturne: number;
    hOrdDiurne: number;
    hOrdNotturne: number;
    hEccDiurne: number;
    hEccNotturne: number;
    hEccDiurneNC: number;
    hEccNotturneNC: number;
    hOrdDiurneNC: number;
    hOrdNotturneNC: number;
    hMancanti: number;
    mRitardo1: number;
    mRitardo2: number;
    mRitardo3: number;
    mRitardo4: number;
}

export class RiepilogoOrePlus {

    static factory: ObjectFactory<RiepilogoOrePlus> = (json?: Partial<RiepilogoOrePlus>) => {
        return merge<RiepilogoOrePlus, Partial<RiepilogoOrePlus> | undefined>({
            hPrevMod: 0,
            hTotali: 0,
            hPrevDiurne: 0,
            hPrevDiurneTurno: 0,
            hPrevNotturne: 0,
            hPausaDiurne: 0,
            hPausaNotturne: 0,
            hLavDiurne: 0,
            hLavNotturne: 0,
            hOrdDiurne: 0,
            hOrdNotturne: 0,
            hEccDiurne: 0,
            hEccNotturne: 0,
            hEccDiurneNC: 0,
            hEccNotturneNC: 0,
            hOrdDiurneNC: 0,
            hOrdNotturneNC: 0,
            hMancanti: 0,
            mRitardo1: 0,
            mRitardo2: 0,
            mRitardo3: 0,
            mRitardo4: 0,
        }, json);
    }


    static hasMancante = function (riepilogo: RiepilogoOrePlus) {
        return riepilogo.hMancanti > 0;
    };
    static hasEccedente = function (riepilogo: RiepilogoOrePlus) {
        return (riepilogo.hEccDiurne + riepilogo.hEccNotturne) > 0;
    };

    static getTotaleRitardo = function (riepilogo: RiepilogoOrePlus) {
        return riepilogo.mRitardo1 + riepilogo.mRitardo2 + riepilogo.mRitardo3 + riepilogo.mRitardo4;
    };

    static getTotaleHLav = function (riepilogo: RiepilogoOrePlus | null) {
        return riepilogo ? riepilogo.hOrdDiurne + riepilogo.hOrdNotturne + riepilogo.hEccDiurne + riepilogo.hEccNotturne : 0;
    };

    static getTotaleHOrd = function (riepilogo: RiepilogoOrePlus) {
        return riepilogo.hOrdDiurne + riepilogo.hOrdNotturne;
    };

    static getTotaleHEcc = function (riepilogo: RiepilogoOrePlus) {
        return riepilogo.hEccDiurne + riepilogo.hEccNotturne;
    };
    static getTotaleHEccNC = function (riepilogo: RiepilogoOrePlus) {
        return riepilogo.hEccDiurneNC + riepilogo.hEccNotturneNC;
    };
    static getTotaleHOrdNC = function (riepilogo: RiepilogoOrePlus) {
        return riepilogo.hOrdDiurneNC + riepilogo.hOrdNotturneNC;
    };
    static getTotaleDiurno = function (riepilogo: RiepilogoOrePlus) {
        return riepilogo.hOrdDiurne + riepilogo.hEccDiurne;
    };
    static isCorrectDiurno = function (riepilogo: RiepilogoOrePlus) {
        return (riepilogo.hLavDiurne - RiepilogoOrePlus.getTotaleDiurno(riepilogo) - riepilogo.hEccDiurneNC - riepilogo.hOrdDiurneNC) === 0;
    };
    static getTotaleNotturno = function (riepilogo: RiepilogoOrePlus) {
        return riepilogo.hOrdNotturne + riepilogo.hEccNotturne;
    };
    static isCorrectNotturno = function (riepilogo: RiepilogoOrePlus) {
        return (riepilogo.hLavNotturne - RiepilogoOrePlus.getTotaleNotturno(riepilogo) - riepilogo.hEccNotturneNC - riepilogo.hOrdNotturneNC) === 0;
    };

    static getTotaleHPrev = function (riepilogo: RiepilogoOrePlus | null) {
        return riepilogo ? riepilogo.hPrevDiurne + riepilogo.hPrevNotturne : 0;
    };

    //riepilogo.getTotaleHContr = function (riepilogo:RiepilogoOrePlus) {
    //TBD: modificare con valori corretti.
    //return riepilogo.hPrevDiurne + riepilogo.hPrevNotturne;
    //};

    static isTotHLavTooMuch = function (riepilogo: RiepilogoOrePlus) {
        return RiepilogoOrePlus.getTotaleHLav(riepilogo) >= 2880;// (48 h * 60 minuti)
    };

    static clear = function (riepilogo: RiepilogoOrePlus | null) {
        return riepilogo ? RiepilogoOrePlus.asMinutes(riepilogo, 0) : riepilogo;
    };

    static asMinutes = function (riepilogo: RiepilogoOrePlus, k: number = 0) {
        riepilogo.hPrevDiurne *= k;
        riepilogo.hPrevNotturne *= k;

        riepilogo.hOrdDiurne *= k;
        riepilogo.hOrdNotturne *= k;

        riepilogo.hEccDiurne *= k;
        riepilogo.hEccNotturne *= k;

        riepilogo.hLavDiurne *= k;
        riepilogo.hLavNotturne *= k;

        riepilogo.hMancanti *= k;

        // Solo per reset, sono normalmente in minuti!
        if (k === 0) {
            riepilogo.hEccDiurneNC *= k;
            riepilogo.hEccNotturneNC *= k;

            riepilogo.hOrdDiurneNC *= k;
            riepilogo.hOrdNotturneNC *= k;

            riepilogo.hPausaDiurne *= k;
            riepilogo.hPausaNotturne *= k;

            riepilogo.mRitardo1 *= k;
            riepilogo.mRitardo2 *= k;
            riepilogo.mRitardo3 *= k;
            riepilogo.mRitardo4 *= k;
        }
        return riepilogo;
    };

    static add = function (riepilogo: RiepilogoOrePlus | null, fromTotali: RiepilogoOrePlus) {
        if (riepilogo === null)
            return null;

        riepilogo.hPrevDiurne += fromTotali.hPrevDiurne;
        riepilogo.hPrevNotturne += fromTotali.hPrevNotturne;

        riepilogo.hOrdDiurne += fromTotali.hOrdDiurne;
        riepilogo.hOrdNotturne += fromTotali.hOrdNotturne;

        riepilogo.hEccDiurne += fromTotali.hEccDiurne;
        riepilogo.hEccNotturne += fromTotali.hEccNotturne;
        riepilogo.hEccDiurneNC += fromTotali.hEccDiurneNC;
        riepilogo.hEccNotturneNC += fromTotali.hEccNotturneNC;

        riepilogo.hOrdDiurneNC += fromTotali.hOrdDiurneNC;
        riepilogo.hOrdNotturneNC += fromTotali.hOrdNotturneNC;

        riepilogo.hLavDiurne += fromTotali.hLavDiurne;
        riepilogo.hLavNotturne += fromTotali.hLavNotturne;

        riepilogo.hMancanti += fromTotali.hMancanti;

        riepilogo.mRitardo1 += fromTotali.mRitardo1;
        riepilogo.mRitardo2 += fromTotali.mRitardo2;
        riepilogo.mRitardo3 += fromTotali.mRitardo3;
        riepilogo.mRitardo4 += fromTotali.mRitardo4;

        riepilogo.hPausaDiurne += fromTotali.hPausaDiurne;
        riepilogo.hPausaNotturne += fromTotali.hPausaNotturne;
        return riepilogo;
    };

    static calcolaMancante = function (riepilogo: RiepilogoOrePlus, distribuzione: TurnoDistribuzioneRecord) {
        let mancante = riepilogo.hPrevDiurne + riepilogo.hPrevNotturne - riepilogo.hOrdDiurne - riepilogo.hOrdNotturne;
        if (!distribuzione.decurtaPausa) {
            mancante -= riepilogo.hPausaDiurne;
            mancante -= riepilogo.hPausaNotturne;
        }
        return mancante;
    };

    static calcolaConESenzaTimbrature = function (riepilogo: RiepilogoOrePlus, causali: CausaliGiornata, giustificativi: GiustificativoRecord[], distribuzione?: TurnoDistribuzioneRecord): boolean {
        {   // Pulisco oggetto!
            const previstoDiurno = riepilogo.hPrevDiurne;
            const previstoNotturno = riepilogo.hPrevNotturne;
            RiepilogoOrePlus.clear(riepilogo);
            riepilogo.hPrevDiurne = previstoDiurno;
            riepilogo.hPrevNotturne = previstoNotturno;

        }
        let lavorato = 0;
        let mancante = 0;
        let eccedenteDiurno = 0;
        let eccedenteNotturno = 0;
        let success = true;

        causali.filter(giu => giu && giu.tipoGiu === 'ORARIO').forEach(giu => {
            const giustificativo = giustificativi.find(v => v.codGiu!.toLowerCase() === giu!.codGiu.toLowerCase()) || null;
            if (giustificativo) {
                switch (giustificativo.tipoOreGiu) {
                    case 'X':
                    case 'O':
                        lavorato += giu!.quantita;
                        break;
                    case 'M':
                        mancante += giu!.quantita;
                        break;
                    case 'E':
                    case 'S':
                        eccedenteDiurno += giu!.quantita;
                        break;
                    case 'N':
                    case 'T':
                        eccedenteNotturno += giu!.quantita;
                        break;
                    default:
                        break;
                }
            }
        })
        if (distribuzione && !distribuzione.decurtaPausa) {
            mancante -= riepilogo.hPausaDiurne;
            mancante -= riepilogo.hPausaNotturne;
        }
        lavorato *= 60.0;
        mancante *= 60.0;
        eccedenteDiurno *= 60.0;
        eccedenteNotturno *= 60.0;
        riepilogo.hOrdDiurne = riepilogo.hPrevDiurne + lavorato - mancante;
        riepilogo.hOrdNotturne = riepilogo.hPrevNotturne;
        if (riepilogo.hOrdDiurne < 0) {
            riepilogo.hOrdNotturne += riepilogo.hOrdDiurne;
            riepilogo.hOrdDiurne = 0;
            if (riepilogo.hOrdNotturne < 0) {
                riepilogo.hOrdNotturne = 0;
                // ERRORE!!!
                success = false;
            }
        }
        riepilogo.hMancanti = mancante;
        riepilogo.hEccDiurne = eccedenteDiurno;
        riepilogo.hEccNotturne = eccedenteNotturno;
        riepilogo.hLavDiurne = riepilogo.hOrdDiurne + riepilogo.hEccDiurne;
        riepilogo.hLavNotturne = riepilogo.hOrdNotturne + riepilogo.hEccNotturne;
        return success;
    };
}